import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import NiceModal from '@ebay/nice-modal-react';
import App from './App';
import GlobalStyle from './GlobalStyles';
import reportWebVitals from './reportWebVitals';
import { defaultTheme } from './theme';

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <GlobalStyle />
      <ThemeProvider theme={defaultTheme}>
        <NiceModal.Provider>
          <App />
        </NiceModal.Provider>
      </ThemeProvider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
